import moment from 'moment';
import * as Yup from 'yup'

// patientsNationalityOptions 
export const PatientsNationalityOptions = [
    { value: 'Indian', label: 'Indian' },
    { value: 'International', label: 'International' }
];

//Primary Refractory Options
export const PrimaryRefractoryOptions = [
    { value: '1', label: 'Yes' },
    { value: '0', label: 'No' }
]

//Bulky Disease Options
export const BulkyDiseaseOptions = [
    { value: '1', label: 'Yes ( >7 cm )' },
    { value: '0', label: 'No ( <7 cm )' }
]

//Bulky Disease Options
export const primaryDiagnosisOptions = [
    { value: '1', label: 'B-ALL' },
    { value: '2', label: 'DLBCL' },
    { value: '3', label: 'B-NHL' },
]
//Bulky Disease Options
export const primaryDiagnosisSubtypeOptions = [
    { value: '1', label: 'GCB' },
    { value: '2', label: 'ABC' },
]


export const SUPPORTED_FORMATS = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
];

export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB

export const fileArraySchema = Yup.array()
    .of(
        Yup.mixed()
            .test("fileType", "Unsupported file format", file =>
                file ? SUPPORTED_FORMATS.includes(file.file_type) : true
            )
            .test("fileSize", "File too large (max 25MB)", file =>
                file ? file.file_size < MAX_FILE_SIZE : true
            )
    )
    .nullable();

export const PreScreenValidationSchema = Yup.object().shape({
    hospital_name: Yup.string()
        .max(255, "Enter less than 255 characters"),
    patient_name: Yup.string()
        .max(50, "Enter less than 50 characters"),
    patient_age: Yup.string().required("Patient age is required"),
    patient_body_weight: Yup.number()
        .typeError("Patient weight must be a number")
        .required("Patient  weight is required")
        .max(200, "Enter less than 200 number")
        .test(
            "decimal-places",
            "Patient weight must have at most 2 decimal places",
            (value) => /^\d+(\.\d{1,2})?$/.test(value?.toString())
        ),
    gender: Yup.string().required("Please select an option"),
    patients_nationality: Yup.string()
        .required("Please select a patient's nationality")
        .nullable(),
    state_id: Yup.string().when('patients_nationality', {
        is: 'Indian',
        then: Yup.string().required('Please select a state').nullable(),
        otherwise: Yup.string().notRequired().nullable()
    }),
    city_id: Yup.string().when('patients_nationality', {
        is: 'Indian',
        then: Yup.string().required('Please select a city').nullable(),
        otherwise: Yup.string().notRequired().nullable()
    }),
    mention_nationality: Yup.string().when('patients_nationality', {
        is: 'International',
        then: Yup.string().required('Please enter nationality'),
        otherwise: Yup.string().notRequired()
    }),

    primary_diagnosis_id: Yup.number()
        .typeError("Must be a number")
        .required("Please select a primary diagnosis")
        .nullable(),
    subtype: Yup.string()
        .when('primary_diagnosis_id', {
            is: (val) => val == "2",
            then: Yup.string().required('Please select subtype').nullable(),
            otherwise: Yup.string().notRequired().nullable(),
        }),

    // File upload validations
    "biopsy-report": fileArraySchema.when('primary_diagnosis_id', {
        is: 1,
        then: fileArraySchema
            .required('Please upload biopsy report')
            .min(1, 'Please upload at least one biopsy report file'),
        otherwise: fileArraySchema.notRequired()
    }),

    "flow-cytometry": fileArraySchema.when('primary_diagnosis_id', {
        is: 1,
        then: fileArraySchema
            .required('Please upload flow cytometry report')
            .min(1, 'Please upload at least one flow cytometry report'),
        otherwise: fileArraySchema.notRequired()
    }),

    "ihc-report": fileArraySchema.when('primary_diagnosis_id', {
        is: val => val === 2 || val === 3,
        then: fileArraySchema
            .required('Please upload IHC report')
            .min(1, 'Please upload at least one IHC report'),
        otherwise: fileArraySchema.notRequired()
    }),

    "pet-scan": fileArraySchema.when('primary_diagnosis_id', {
        is: val => val === 2 || val === 3,
        then: fileArraySchema
            .required('Please upload PET scan report')
            .min(1, 'Please upload at least one PET scan report'),
        otherwise: fileArraySchema.notRequired()
    }),

    "discharge-summary": fileArraySchema.when('primary_diagnosis_id', {
        is: val => [1, 2, 3].includes(val),
        then: fileArraySchema
            .required('Please upload discharge summary report')
            .min(1, 'Please upload at least one discharge summary report'),
        otherwise: fileArraySchema.notRequired()
    }),

    "cytogenetics-report": fileArraySchema.when('primary_diagnosis_id', {
        is: val => [1, 2, 3].includes(val),
        then: fileArraySchema
            .required('Please upload cytogenetics report')
            .min(1, 'Please upload at least one cytogenetics report'),
        otherwise: fileArraySchema.notRequired()
    }),

    cytogenetic_molecular_abnormalities: Yup.string()
        .required("Cytogenetic / molecular abnormalities is required")
        .max(255, "Enter less than 255 characters"),

    biopsy_confirmed: Yup.string()
        .required("Please select a biopsy confirmed")
        .nullable(),
    cytogenetic_report: Yup.string()
        .required("Please select a cytogenetic report")
        .nullable(),
    "biopsy-confirmed-report": fileArraySchema.when('biopsy_confirmed', {
        is: '1',
        then: fileArraySchema
            .required('Please upload biopsy confirmed report')
            .min(1, 'Please upload at least one biopsy confirmed report'),
        otherwise: fileArraySchema.notRequired()
    }),
    "karyotyping-report": fileArraySchema.when('cytogenetic_report', {
        is: '1',
        then: fileArraySchema
            .required('Please upload karyotyping report')
            .min(1, 'Please upload at least one karyotyping report'),
        otherwise: fileArraySchema.notRequired()
    }),

    date_of_last_relapse_or_refractoriness: Yup.string().required("Date of last relapse or refractoriness is required"),
    number_of_lines_of_therapies_prior_to_car_t: Yup.number()
        .required("Number of prior lines of therapy is required")
        .typeError("Must be a number")
        .integer("Only whole numbers are allowed")
        .max(100, "Enter less than or equal to 100").nullable(),
    primary_refractory: Yup.string()
        .required("Please select a primary refractory")
        .nullable(),
    treatment_history: Yup.array()
        .min(1, "Treatment history are required")
        .of(
            Yup.object().shape({
                treatment_for: Yup.string().required("Drug(s) is required"),
                start_date: Yup.string().required("Start date is required"),
                end_date: Yup.string().required("End date is required"),
            })
        ),
    last_treatment_regimen: Yup.string()
        .required("Last treatment regimen is required")
        .max(200, "Enter less than 200 characters"),
    last_treatment_dates: Yup.object().shape({
        start_date: Yup.string().required("Start date is required"),
        stop_date: Yup.string().required("End date is required"),
    }),
    bulky_disease_dlbcl: Yup.string()
        .required("Bulky disease (dlbcl) is required")
        .max(200, "Enter less than 200 characters"),
    b_all_blast_percentage: Yup.number()
        .typeError("Must be a number")
        .required("Bulky disease - B-ALL is required")
        .nullable(),
    ecog_ps: Yup.number().required("ECOG performance score is required").typeError("Must be a number").max(1000, "Enter less than 1000 number").nullable(),
    lvef_percentage: Yup.number().required("LVEF % is required").typeError("Must be a number").max(1000, "Enter less than 1000 number").nullable(),
    baseline_crp_level: Yup.number().required("Baseline crp  is required").typeError("Must be a number").max(1000, "Enter less than 1000 number").nullable(),
    baseline_ldh_level: Yup.number().required("Baseline ldh  is required").typeError("Must be a number").max(1000, "Enter less than 1000 number").nullable(),
    baseline_lymphocyte_to_monocyte_ratio: Yup.number()
        .typeError("Must be a number").required("Lymphocyte monocyte ratio is required").max(1000, "Enter less than 1000 number").nullable(),
    family_annual_income: Yup.string()
        .max(100, "Enter less than 100 characters"),
    patient_occupation: Yup.string()
        .max(155, "Enter less than 155 characters"),

    // Optional file uploads
    "csf-report": fileArraySchema.notRequired(),
    "bcrabl-report": fileArraySchema.notRequired(),
    "bone-marrow-involvement": fileArraySchema.notRequired(),
    "chimerism-report": fileArraySchema.notRequired(),
    "apheresisDateRange": Yup.object()
        .shape({
            startDate: Yup.date()
                .required('Date is required')
                .typeError('Please select a valid start date'),
            endDate: Yup.date()
                .required('Date is required')
                .typeError('Please select a valid end date')
                .min(
                    Yup.ref('startDate'),
                    'End date must be after start date'
                ),
        })
        .required('Date range is required')
        .test(
            'is-valid-range',
            'Please select a valid date range',
            function(value) {
                if (!value || !value.startDate || !value.endDate) {
                    return false;
                }
                return value.startDate <= value.endDate;
            }
        ),
        preferred_date: Yup.array()
        .of(Yup.string())
         .notRequired()
        .test(
            'len-check',
            'You can select between 1 and 5 preferred dates',
            value => !value || value?.length == 0 || (value.length >= 1 && value.length <= 5)
        )
       
});


export const clinicalStatus = [
    { lable: "Pending", color: "warning", bgColor: "#FFEDCB", text: "#FB9D2C" },
    { lable: "Clinical Feasible", color: "success", bgColor: "#E4F9F2", text: "#00B278" },
    { lable: "Feasible with Conditions", color: "success", bgColor: "#E4F9F2", text: "#00B278" },
    { lable: "Not Feasible", color: "error", bgColor: "#FFE3E3", text: "#FF2023" }
]
export const financialStatus = [
    { lable: "Pending", color: "warning", bgColor: "#FFEDCB", text: "#FB9D2C" },
    { lable: "Financial Feasible", color: "success", bgColor: "#E4F9F2", text: "#00B278" },
    { lable: "Not Feasible", color: "error", bgColor: "#FFE3E3", text: "#FF2023" },
    { lable: "Special Approval", color: "success", bgColor: "#E4F9F2", text: "#00B278" },
    { lable: "Not Applicable", color: "warning", bgColor: "#FFEDCB", text: "#FB9D2C" }
]
export const paymentTypeOptions = [
    { value: '1', label: 'Self-Paid' },
    { value: '2', label: 'Insurance' },
    { value: '3', label: 'ECHS' },
    { value: '4', label: 'CGHS' },
];

export function transformDataWithFiles(data) {
    const transformedFiles = {};

    if (Array.isArray(data.files)) {
        data.files.forEach(file => {
            if (file.file_key && file.media) {
                transformedFiles[file.file_key] = file.media;
            }
        });
    }

    const { ...rest } = data;

    return {
        ...rest,
        ...transformedFiles
    };
}


export const returnPostData = (values) => {
    const result = Object.fromEntries(
        Object.entries(values).map(([key, value]) => {
            if (Array.isArray(value) && key != "treatment_history" && key != "preferred_date") {
                const ids = value
                    .filter(obj => obj && typeof obj === 'object' && 'id' in obj)
                    .map(obj => obj.id);
                return [key, ids];
            }
            return [key, value];
        })
    );
    return result
}

export function getNestedValue(obj, path) {
    if (!path) return undefined;
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}

export const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Returns format: YYYY-MM-DD
};

export function isValidDynamicDate(dateStr) {
    // Common date formats to check (strictly)
    const commonFormats = [
        'DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD',
        'DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY/MM/DD',
        'DD.MM.YYYY', 'MM.DD.YYYY', 'YYYY.MM.DD',
        'D-M-YYYY', 'M-D-YYYY', 'YYYY-M-D', // Handles single-digit days/months
        'DD MMM YYYY', 'MMM DD YYYY' // Like '29 Jun 2025'
    ];

    // Try each format with strict parsing
    for (const format of commonFormats) {
        if (moment(dateStr, format, true).isValid()) {
            return true;
        }
    }

    // Fallback: Let Moment.js guess (less reliable)
    return moment(dateStr).isValid();
}